/* eslint-disable import/no-anonymous-default-export */
import { CognitoUserPool } from "amazon-cognito-identity-js";


const userpoolID = process.env.REACT_APP_USER_POOL_ID;
const clientId = process.env.REACT_APP_CLIENT_ID;

//Heco Analytics Credentials in Amazon S3 bucket
const poolData = {
  UserPoolId: userpoolID,
  ClientId: clientId,
};

export default new CognitoUserPool(poolData);
